import { Link } from 'react-router-dom';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Style 4: Default mixed grid — 1 big lead + small thumbs beside + bottom row of 3.
export default function Style4Block({ category, articles }) {
  if (!articles || articles.length === 0) return null;
  const lead = articles[0];
  const asides = articles.slice(1, 4);
  const bottom = articles.slice(4, 7);
  const color = category?.color || '#3b82f6';

  const resolve = (u) => u ? (u.startsWith('http') ? u : `${BACKEND}${u}`) : null;

  return (
    <div className="space-y-5" data-testid="style4-mixed">
      <div className="grid md:grid-cols-5 gap-4">
        {/* Lead */}
        {lead && (
          <Link to={`/clanak/${lead.slug}`} className="md:col-span-3 group block relative rounded-xl overflow-hidden bg-gray-100 dark:bg-[#111827] aspect-[16/10]">
            {lead.cover_image_url && <img src={resolve(lead.cover_image_url)} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
              <span className="inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded mb-2" style={{ backgroundColor: color }}>{category.name_hr}</span>
              <h3 className="text-xl md:text-2xl font-extrabold leading-tight line-clamp-3">{lead.title_hr}</h3>
            </div>
          </Link>
        )}
        {/* Asides */}
        <div className="md:col-span-2 grid gap-3">
          {asides.map(a => (
            <Link key={a.id} to={`/clanak/${a.slug}`} className="flex gap-3 group">
              {a.cover_image_url && (
                <div className="shrink-0 w-24 h-20 rounded-lg overflow-hidden bg-gray-100 dark:bg-[#111827]">
                  <img src={resolve(a.cover_image_url)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
                </div>
              )}
              <div className="min-w-0 flex-1">
                <h4 className="text-sm font-bold leading-snug line-clamp-3 text-gray-900 dark:text-gray-100 group-hover:text-red-600">{a.title_hr}</h4>
                {a.published_at && <p className="text-[10px] text-gray-400 mt-1 uppercase tracking-wider">{new Date(a.published_at).toLocaleDateString('hr')}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>
      {/* Bottom row */}
      {bottom.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 pt-5 border-t border-gray-100 dark:border-gray-800">
          {bottom.map(a => (
            <Link key={a.id} to={`/clanak/${a.slug}`} className="group">
              {a.cover_image_url && (
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-gray-100 dark:bg-[#111827] mb-2">
                  <img src={resolve(a.cover_image_url)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
                </div>
              )}
              <h4 className="text-xs font-bold leading-snug text-gray-900 dark:text-gray-100 group-hover:text-red-600 line-clamp-2">{a.title_hr}</h4>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
